// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignDescription_container__21SUV","description":"CampaignDescription_description__1NJg8"};